import React, { createContext, useState } from "react";
import {Producer} from "@main/producers/models/Producer";

interface ConfigurationActionContextType {  
  backendFormErrors: any;
  setBackendFormErrors: (backendFormErrors: any) => void;    
  element: Producer;
  setElement: (element: any) => void;  
}

export const ConfigurationActionContext = createContext<ConfigurationActionContextType>({
  backendFormErrors: {},
  setBackendFormErrors: () => {},  
  element: new Producer(),
  setElement: () => {},  
});

interface ConfigurationActionProviderProps {
  children: React.ReactNode;
}

export const ConfigurationActionProvider: React.FC<ConfigurationActionProviderProps> = ({
  children,
}) => {  
  const [backendFormErrors, setBackendFormErrors] = useState(null);
  const [element, setElement] = useState<any>(new Producer());

  const value = {    
    backendFormErrors,
    setBackendFormErrors,
    element,
    setElement,    
  };
  return (
    <ConfigurationActionContext.Provider value={value}>      
      {children}
    </ConfigurationActionContext.Provider>
  );
};
